/** messaging group: threads and messages (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const messagingPermissions = ['message:read', 'message:send'] as const;

export type MessagingPermission = (typeof messagingPermissions)[number];
